import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Table from "react-bootstrap/Table";

import TextCell from "./cells/TextCell";
import TextLinkCell from "./cells/TextLinkCell";
import OrderCell from "./cells/OrderCell";
import ColorCell from "./cells/ColorCell";
import HiddenCell from "./cells/HiddenCell";
import CheckBoxCell from "./cells/CheckBoxCell";
import BooleanCell from "./cells/BooleanCell";
import ImageCell from "./cells/ImageCell";
import TableHeader from "./TableHeader";
import PdfCell from "./cells/PdfCell";
import ClipboardCell from "./cells/ClipboardCell";
import GroupRadioCell from "./cells/GroupRadioCell";

const DataTable = ({ tableProps }) => {
  let projectPath = useParams();
  let projectid = projectPath["*"];
  let [canRenderTable, setCanRenderTable] = useState(false);

  let [tableColumns, setTableColumns] = useState(tableProps.tableColumns || []);
  let [tableColumnSchema, setTableColumnSchema] = useState(
    tableProps.tableColumnSchema || []
  );

  let tableData = tableProps.tableData || [];

  useEffect(() => {
    if (tableData.length > 0) {
      setCanRenderTable(true);
    }
  }, [tableData]);

  return (
    <>
      {canRenderTable && (
        <div className="indi-data-table-wrapper">
          <Table responsive="sm">
            <thead className="indi-data-table-header">
              <tr>
                {tableColumns.map((col, index) => (
                  <TableHeader key={index} props={{ tableColumnSchema, col }} />
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((data, index) => {
                let isQuiz = false;
                let isUpdatedView = false;

                let isQuizColIndex = tableColumns.indexOf("quiz");
                let isUpdatedViewColIndex = tableColumns.indexOf("updatedView");
                if (isQuizColIndex !== -1) {
                  isQuiz = data[isQuizColIndex];
                }

                if (isUpdatedViewColIndex !== -1) {
                  isUpdatedView = data[isUpdatedViewColIndex];
                }
                return (
                  <tr key={index} className="indi-data-table-tr">
                    {tableColumns.map((col, colIndex) => {
                      /*
                       * The group radio belongs to the entire table/group,
                       * so render it only on the first row and span all rows.
                       */
                      if (tableColumnSchema[col]?.type === "groupRadio" && index > 0) {
                        return null;
                      }

                      return (
                        <td
                          key={`${colIndex}`}
                          rowSpan={
                            tableColumnSchema[col]?.type === "groupRadio"
                              ? tableData.length
                              : undefined
                          }
                          className={
                            "indi-data-table-td " +
                            (tableColumnSchema[col]?.classes || "") +
                            (tableColumnSchema[col]?.type === "hidden"
                              ? "d-none"
                              : "")
                          }
                        >
                          {tableColumnSchema[col]?.type === "order" && (
                            <OrderCell
                              props={{
                                data,
                                colIndex,
                                rowIndex: index,
                                tableProps,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "link" && (
                            <TextLinkCell
                              props={{
                                data,
                                projectid,
                                isQuiz,
                                isUpdatedView,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "color" && (
                            <ColorCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "text" && (
                            <TextCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "hidden" && (
                            <HiddenCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "checkbox" && (
                            <CheckBoxCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                                tableProps,
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "groupRadio" && (
                            <GroupRadioCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                                tableProps,
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "image" && (
                            <ImageCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "boolean" && (
                            <BooleanCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                                tableColumns,
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "search" && (
                            <TextCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "pdfLink" && (
                            <PdfCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                              }}
                            />
                          )}
                          {tableColumnSchema[col]?.type === "clipboard" && (
                            <ClipboardCell
                              props={{
                                data,
                                colIndex,
                                schema: tableColumnSchema[col],
                                tableColumns,
                              }}
                            />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default DataTable;
